(function() {
  function closeSymmetrySearchDrawer() {
    // Run only on product pages
    if (!document.body.classList.contains('template-product')) return;

    // Target the Symmetry ajax search drawer
    const searchDrawer = document.querySelector('.ajax-search');
    if (searchDrawer) {
      searchDrawer.classList.remove('is-open', 'open', 'active', 'predictive-search--open');
      searchDrawer.style.transform = 'translateX(-100%)';
      searchDrawer.style.opacity = '0';
      searchDrawer.style.pointerEvents = 'none';
      searchDrawer.setAttribute('aria-hidden', 'true');
    }

    // Remove leftover overlays
    document.querySelectorAll('.drawer__overlay, .predictive-search__overlay, .menu-drawer__overlay').forEach(el => el.remove());

    // Release scroll locks
    document.documentElement.classList.remove('js-drawer-open', 'overflow-hidden', 'no-scroll');
    document.body.classList.remove('js-drawer-open', 'overflow-hidden', 'no-scroll');
  }

  window.addEventListener('load', closeSymmetrySearchDrawer);
  window.addEventListener('pageshow', closeSymmetrySearchDrawer);
})();
